import React from 'react';
import './cssfiles/Achievements.css';
import image1 from './images/developing.png';
import Image2 from './images/celebrating_2454273.png';
import image3 from './images/trophy.png';


function Achievements() {
  return (
    <div className="achievements-section" id="achievements-section">
      <h2>Achievements</h2>
      <p>
  I've delivered production systems across <span className="highlight">travel, edtech,  healthcare, enterprise, and events</span>
</p>
      <ul className="achievement-list">
        <li>
          <img src={image1} alt="Icon 1" className='imgstyle' />
          <div>
            <h3>8+</h3>
            <p>8+ years of experience in software development — 3 years Java/Spring Boot backend, 5+ years React & React Native.</p>
          </div>
        </li>
        <li>
          <img src={Image2} alt="Icon 2" className='imgstyle' />
          <div>
            <h3>95%</h3>
            <p>Client satisfaction rate across all projects, with consistent on-time delivery.</p>
          </div>
        </li>
        <li>
          <img src={image3} alt="Icon 3" className='imgstyle'/>
          <div>
            <h3>10+</h3>
            <p>10+ production applications delivered across backend systems, web platforms, and mobile apps.</p>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default Achievements;